export const environment = {
  production: false,
  api: {
    baseUrl: 'https://dev-api.tabify.no',
    v1: {
      transactions: '/api/v1/transactions',
      wallet: '/api/v1/wallet',
    },
  },
  worldline: {
    googlePayMerchantId: '12345678901234567890',
    googlePayEnvironment: 'TEST',
    /**
     * Per-branch Worldline gateway merchant ID, keyed by `partnerBranchId`
     * (GUID) from the transaction response. Sole source of truth — no
     * platform-wide fallback.
     */
    branchMerchantIds: {
      '657e7659-c5b7-4b67-ab7d-756f01517ab1': 'T373299501', // Døgnvill — Bjorvika
      '9e71d8f8-dce7-474c-b98a-ae484010d797': 'T373299501', // Døgnvill — Tjuvholmen
      '8b7f8075-801c-4509-c8c5-08de409b750b': 'T468378001', // Døgnvill — Vulkan
    } as Record<string, string>,
  },
  posthog: {
    apiKey: 'phc_tU5uhCjx91JlLfJ97y8pS6F9e1qwEhXyuwKYQLI4LxE',
    apiHost: 'https://eu.i.posthog.com',
  },
};
